import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { getUser } from './get-user';

/** `PATCH /client/:cid/users/:id {mobile_no}`: 409 when another user has the number. */
export const editUserPhone = async (user_id: string, mobile_no: string): Promise<any> => {
  await lpRequest('PATCH', clientPath(`/users/${user_id}`), {
    body: { mobile_no: mobile_no.replace(/\s/g, '') }
  });

  return getUser(user_id);
};
